var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebReklamYoenetimi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "142px",
    height: "142px",
    viewBox: "185 185 142 142",
    enableBackground: "new 185 185 142 142",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M306.185,202.098H205.815c-3.08,0-5.576,2.497-5.576,5.576v96.652c0,3.079,2.497,5.576,5.576,5.576h100.369 c3.08,0,5.576-2.497,5.576-5.576v-96.652C311.761,204.595,309.265,202.098,306.185,202.098z M205.815,205.815h100.369 c1.026,0,1.858,0.832,1.858,1.858v9.294H203.957v-9.294C203.957,206.647,204.789,205.815,205.815,205.815z M306.185,306.185 H205.815c-1.027,0-1.859-0.832-1.859-1.858v-83.642h104.086v83.642C308.043,305.353,307.211,306.185,306.185,306.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M276.161,255.474c2.928-2.85,2.99-7.533,0.141-10.461c-1.894-1.944-4.699-2.696-7.312-1.959l-3.663-6.347 c-1.026-1.779-3.3-2.389-5.078-1.363c-0.193,0.112-0.376,0.24-0.547,0.385l-29.995,25.444c-0.685,0.58-0.857,1.567-0.409,2.345 l0.93,1.61l-3.219,1.858c-1.778,1.027-2.387,3.301-1.361,5.078l3.717,6.438c0.665,1.152,1.895,1.86,3.225,1.858 c1.745-0.662,3.44-1.449,5.072-2.354l9.293,16.097c0.247,0.427,0.652,0.738,1.128,0.866c0.476,0.127,0.983,0.061,1.411-0.187 l6.438-3.717c0.889-0.514,1.194-1.65,0.68-2.539l-6.574-11.389l27.823-9.959c1.932-0.693,2.937-2.822,2.242-4.755 c-0.075-0.209-0.169-0.411-0.28-0.604L276.161,255.474z M232.581,276.646l-3.717-6.438l3.219-1.858l3.717,6.438L232.581,276.646z  M274.186,248.333c0.661,1.146,0.661,2.557,0,3.702l-3.201-5.544C272.303,246.494,273.521,247.194,274.186,248.333z  M252.468,288.776l-3.219,1.858l-6.319-10.949l3.558-1.273L252.468,288.776z M241.04,276.414l-7.744-13.41l28.81-24.44 l14.498,25.116L241.04,276.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M260.937,245.307c-0.543-0.096-1.1,0.057-1.519,0.414l-20.172,17.101l2.403,2.844l18.475-15.667 l6.705,11.615l3.221-1.859l-7.819-13.544C261.953,245.733,261.479,245.402,260.937,245.307L260.937,245.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M274.587,235.554h3.718v7.436h-3.718V235.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M278.733,243.229l6.438-3.717l1.858,3.219l-6.438,3.718L278.733,243.229z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M278.739,250.187l1.858-3.22l6.438,3.718l-1.858,3.219L278.739,250.187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,209.532h3.718v3.718h-3.718V209.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,209.532h3.717v3.718h-3.717V209.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M222.543,209.532h3.717v3.718h-3.717V209.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,224.402h3.718v3.717h-3.718V224.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,224.402h11.152v3.717h-11.152V224.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,231.837h3.718v3.717h-3.718V231.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,231.837h7.435v3.717h-7.435V231.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,239.271h3.718v3.718h-3.718V239.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,239.271h3.717v3.718h-3.717V239.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,298.75h3.718v3.717h-3.718V298.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,298.75h11.152v3.717h-11.152V298.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,291.315h3.718v3.717h-3.718V291.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,291.315h7.435v3.717h-7.435V291.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M207.674,283.881h3.718v3.717h-3.718V283.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M215.109,283.881h3.717v3.717h-3.717V283.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M300.608,224.402h3.718v3.717h-3.718V224.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M285.739,224.402h11.152v3.717h-11.152V224.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M300.608,231.837h3.718v3.717h-3.718V231.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M289.456,231.837h7.436v3.717h-7.436V231.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M300.608,239.271h3.718v3.718h-3.718V239.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M293.174,239.271h3.718v3.718h-3.718V239.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M300.608,298.75h3.718v3.717h-3.718V298.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M285.739,298.75h11.152v3.717h-11.152V298.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M300.608,291.315h3.718v3.717h-3.718V291.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M289.456,291.315h7.436v3.717h-7.436V291.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M300.608,283.881h3.718v3.717h-3.718V283.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3B68",
    d: "M293.174,283.881h3.718v3.717h-3.718V283.881z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebReklamYoenetimi);
export default __webpack_public_path__ + "static/media/web-reklam-yoenetimi.955064f3147f2a11c635b44e8403da2a.svg";
export { ForwardRef as ReactComponent };